import React from "react";
import { SendNotification } from "./SendNotification";
import { GridWrapper } from "../GridWrapper/GridWrapper";
import { Card } from "../card";
import { SentNotificationsLists } from "./SentNotificationsLists";

export const NotificationComponent = () => {
  return (
    <GridWrapper
      totalColumns={3}
      childrens={[
        {
          component: (
            <Card
              wrapperStyle={{ height: "100%" }}
              cardTitle="Send notification"
            >
              <div>
                <SendNotification />
              </div>
            </Card>
          ),
          gridSpan: 1,
        },
        {
          component: (
            <Card
              wrapperStyle={{
                height: "100%",
              }}
              cardTitle="All notifications"
            >
              <div>
                <SentNotificationsLists />
              </div>
            </Card>
          ),
          gridSpan: 2,
        },
      ]}
    />
  );
};
